import {Action} from '@ngrx/store';

export interface ToastsMethodCall {
  message: string;
  options?: string | number;
  title?: string;
}

export const toastsAction = {
  ERROR: '[Toasts] Error',
  INFO: '[Toasts] Info',
  SUCCESS: '[Toasts] Success',
  WARNING: '[Toasts] Warning',
  CUSTOM: '[Toasts] Custom',
  CLEAR_ALL: '[Toasts] Clear All'
};

export class ErrorToastAction implements Action {
  readonly type = toastsAction.ERROR;

  constructor(public payload: ToastsMethodCall) {}
}

export class InfoToastAction implements Action {
  readonly type = toastsAction.INFO;

  constructor(public payload: ToastsMethodCall) {}
}

export class SuccessToastAction implements Action {
  readonly type = toastsAction.SUCCESS;

  constructor(public payload: ToastsMethodCall) {}
}

export class WarningToastAction implements Action {
  readonly type = toastsAction.WARNING;

  constructor(public payload: ToastsMethodCall) {}
}

export class CustomToastAction implements Action {
  readonly type = toastsAction.CUSTOM;

  constructor(public payload: ToastsMethodCall) {}
}

export class ClearAllToastsAction implements Action {
  readonly type = toastsAction.CLEAR_ALL;

  constructor() {}
}

export function error(message: string, title?: string, options?: number | string): ErrorToastAction {
  const payload: ToastsMethodCall = { message, title, options };
  return new ErrorToastAction(payload);
}

export function info(message: string, title?: string, options?: string): InfoToastAction {
  const payload: ToastsMethodCall = { message, title, options };
  return new InfoToastAction(payload);
}

export function success(message: string, title?: string, options?: string): SuccessToastAction {
  const payload: ToastsMethodCall = { message, title, options };
  return new SuccessToastAction(payload);
}

export function warning(message: string, title?: string, options?: string): WarningToastAction {
  const payload: ToastsMethodCall = { message, title, options };
  return new WarningToastAction(payload);
}

export function custom(message: string, title?: string, options?: string): CustomToastAction {
  const payload: ToastsMethodCall = { message, title, options };
  return new CustomToastAction(payload);
}

export function clearAll(): ClearAllToastsAction {
  return new ClearAllToastsAction();
}
